import { createAsyncThunk } from '@reduxjs/toolkit'

import { apiGET } from '../../lib/api'
import { TrainEquipmentCirculation } from '../../types/Input'

const fetchTrainEquipmentCirculation = (
  params: TrainEquipmentCirculationParams
): Promise<TrainEquipmentCirculation> =>
  apiGET(`trainEquipmentCirculation?${new URLSearchParams(params).toString()}`)

export type TrainEquipmentCirculationParams = {
  trainNumber: string
  fromStation: string
  toStation: string
  startDateTime: string
  endDateTime: string
}

type FetchTrainEqInfoError = {
  message: string
}

export const fetchTrainEquipmentCirculationAction = createAsyncThunk<
  TrainEquipmentCirculation,
  TrainEquipmentCirculationParams,
  { rejectValue: FetchTrainEqInfoError }
>('train-equipment-circulation/fetchTrainEquipmentCirculation', async (params, thunkApi) => {
  try {
    return await fetchTrainEquipmentCirculation(params)
  } catch (err) {
    return thunkApi.rejectWithValue({
      message: 'Failed to fetch train equipment circulation',
    })
  }
})
